import { render, staticRenderFns } from "./SettingUp.vue?vue&type=template&id=9de216be&scoped=true&"
import script from "./SettingUp.vue?vue&type=script&lang=js&"
export * from "./SettingUp.vue?vue&type=script&lang=js&"
import style0 from "./SettingUp.vue?vue&type=style&index=0&id=9de216be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de216be",
  null
  
)

export default component.exports